/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc). To make a column queryable by index — including boolean/nullable columns — add a single-column Postgres index and re-run `sf dc`; do not hand-edit generated files.
 */

import { isObject, hasPropOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { ScheduleEntryBase } from 'shared/dbo/ScheduleEntry';

export interface ScheduleEntryIndexedDb {
	id: string;
	date: string;
	startTime: string;
	eventTitle: string;
	created: number;
	lastModified: number;
	shortId: string;
}

export const isScheduleEntryIndexedDb = (obj: unknown): obj is ScheduleEntryIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (hasPropOfType<{ deleted: boolean }>(obj, 'deleted', 'boolean') && obj.deleted) {
		return true;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ date: unknown }>(obj, 'date') || !(typeof obj.date === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ startTime: unknown }>(obj, 'startTime') || !(typeof obj.startTime === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ eventTitle: unknown }>(obj, 'eventTitle') || !(typeof obj.eventTitle === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: ScheduleEntryBase): ScheduleEntryIndexedDb => ({
	id: obj.id.toString(),
	date: obj.date.toString(),
	startTime: obj.startTime.toString(),
	eventTitle: obj.eventTitle,
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: ScheduleEntryIndexedDb): ScheduleEntryBase => ({
	id: UUID.fromString(obj.id),
	date: Temporal.PlainDate.from(obj.date),
	startTime: Temporal.PlainTime.from(obj.startTime),
	eventTitle: obj.eventTitle,
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdScheduleEntry: LocalDatabaseTableDefinition<ScheduleEntryBase, ScheduleEntryIndexedDb> = {
	tableName: 'scheduleEntries',
	indexColumns: ['date'],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
